import { useEffect, useState } from 'react';
import { ambience, soundBoard } from '../lib/sound';

/**
 * Lautstärke für Klänge. Der Wert wirkt sofort und wird im Browser gemerkt, damit er nach einem
 * Neuladen erhalten bleibt. Der erste Zugriff weckt zugleich die Tonausgabe auf – Browser lassen
 * Klang erst nach einer Nutzeraktion zu.
 */
/** Schlichter Schieberegler mit Beschriftung und Prozentwert. */
export function Slider({
  label,
  value,
  onChange,
}: {
  label: string;
  value: number;
  onChange: (next: number) => void;
}) {
  return (
    <div className="volume">
      <span className="tiny muted volume-toggle">{label}</span>
      <input
        type="range"
        className="volume-slider"
        min={0}
        max={100}
        step={1}
        value={Math.round(value * 100)}
        aria-label={label}
        onChange={(e) => onChange(Number(e.target.value) / 100)}
      />
      <span className="volume-value">{Math.round(value * 100)}%</span>
    </div>
  );
}

/** Musiklautstärke auf diesem Gerät – jeder regelt sie für sich. */
export function MusicVolumeControl() {
  const [volume, setVolume] = useState(ambience.volume);
  return (
    <Slider
      label="Musik"
      value={volume}
      onChange={(next) => {
        void soundBoard.unlock();
        ambience.setVolume(next);
        setVolume(next);
      }}
    />
  );
}

export function VolumeControl({ compact }: { compact?: boolean }) {
  const [volume, setVolume] = useState(soundBoard.volume);

  useEffect(() => {
    setVolume(soundBoard.volume);
  }, []);

  function change(next: number) {
    void soundBoard.unlock();
    soundBoard.setMuted(false);
    soundBoard.setVolume(next);
    setVolume(next);
  }

  return (
    <div className={`volume${compact ? ' compact' : ''}`}>
      <span className="tiny muted volume-toggle">Soundeffekte</span>
      <input
        type="range"
        className="volume-slider"
        min={0}
        max={100}
        step={1}
        value={Math.round(volume * 100)}
        aria-label="Lautstärke der Soundeffekte"
        onChange={(e) => change(Number(e.target.value) / 100)}
      />
      <span className="volume-value">{Math.round(volume * 100)}%</span>
    </div>
  );
}
